import { useStepTwo } from 'Hooks/useStepTwo'
import ApSelect from '../ApSelect'
import ApSelectWeight from '../ApSelectWeight'
import { ApTextareaTwo } from '../ApTextareaTwo'
import { ApTextareaProps, matricType } from './ApStepTwo'
import './ApStepTwo.scss'
import { HorizontalLoader } from 'Components'

type StepTwo = ReturnType<typeof useStepTwo>

type ApStepTwoViewProps = ApTextareaProps & StepTwo

export const ApStepTwoMobile: React.FC<ApStepTwoViewProps> = (props) => {
  const {
    register,
    errors,
    isManager,
    isAdmin,
    isDisabled,
    preview,
    isManagerDraft,
    kpi,
    kpiPercentage,
    kpiPercentageMgr,
    loading,
  } = props

  return (
    <div>
      <div className='card kpi px-3 border-0 mt-3 mb-3 apStepTwoMob'>
        <div className='card-header px-0'>Performance Evaluation & Feedback</div>
        {loading && <HorizontalLoader />}
        <div className='card-body px-0'>
          <ul className='list-group'>
            {kpi &&
              kpi.map((item: matricType, index: number) => (
                <li className='list-group-item list-item-icon kpi-mobile-item' key={index}>
                  {/* hidden fields */}
                  <input
                    type='hidden'
                    {...register(`kpi.${index}.relevance`)}
                    value={item.relevance}
                  />
                  <input
                    type='hidden'
                    {...register(`kpi.${Number(index)}.metric`)}
                    value={item.metric}
                  />
                  <input
                    type='hidden'
                    {...register(`kpi.${Number(index)}.target`)}
                    value={Number(index)}
                  />
                  <input
                    type='hidden'
                    {...register(`kpi.${Number(index)}.employee_comment`)}
                    value={Number(index)}
                  />

                  <div className='kpi-mobile-row'>
                    <span className='kpi-label'>KPIs (up to 80%)</span>
                    <span className='kpi-value kpi-value-text'>{item.metric}</span>
                  </div>

                  <div className='kpi-mobile-row'>
                    <span className='kpi-label'>Weight (%)</span>
                    <div className='kpi-value kpi-select-con'>
                      <ApSelectWeight
                        name={`kpi.${index}.relevance`}
                        index={index}
                        register={register}
                        errors={errors}
                        rules={!isAdmin ? { required: 'Field is required.' } : {}}
                        disable={isAdmin || isManager || !isDisabled}
                      />
                    </div>
                  </div>

                  <div className='kpi-mobile-row'>
                    <span className='kpi-label'>Appraisee&rsquo;s Score</span>
                    <div className='kpi-value kpi-select-con'>
                      <ApSelect
                        name={`kpi.${index}.employee_score`}
                        index={index}
                        register={register}
                        errors={errors}
                        rules={{ required: 'Field is required.' }}
                        disable={preview ? true : isDisabled}
                      />
                    </div>
                  </div>

                  <div className='kpi-mobile-comment'>
                    <span className='kpi-label'>Appraisee&rsquo;s Comment</span>
                    <ApTextareaTwo
                      name={`kpi.${index}.employee_comment`}
                      index={index}
                      register={register}
                      errors={errors}
                      placeholder='Type here...'
                      disabled={preview ? true : isManager || isAdmin}
                      isDisabled={isDisabled}
                    />
                    {/* <ApInput
                      name={`kpi.${index}.employee_comment`}
                      index={index}
                      register={register}
                      errors={errors}
                      placeholder='Type here...'
                      disabled={isDisabled}
                    /> */}
                  </div>

                  {isManager && (
                    <div className='kpi-mobile-manager'>
                      <div className='kpi-mobile-row'>
                        <span className='kpi-label'>Manager&rsquo;s Score</span>
                        <div className='kpi-value kpi-select-con'>
                          <ApSelect
                            name={isManagerDraft ? 'k' : `kpi.${index}.manager_score`}
                            index={index}
                            register={register}
                            errors={errors}
                            rules={!isAdmin ? { required: 'Field is required.' } : {}}
                            disable={isAdmin}
                          />
                        </div>
                      </div>

                      <div className='kpi-mobile-comment'>
                        <span className='kpi-label'>Manager&rsquo;s Comment</span>
                        <ApTextareaTwo
                          name={isManagerDraft ? 'k' : `kpi.${index}.manager_comment`}
                          index={index}
                          register={register}
                          errors={errors}
                          placeholder='Type here...'
                          disabled={isAdmin}
                        />
                        {/* <ApInput
                            name={`kpi.${index}.manager_comment`}
                            index={index}
                            register={register}
                            errors={errors}
                            placeholder='Type here...'
                            disabled={isAdmin}
                          /> */}
                      </div>
                    </div>
                  )}
                </li>
              ))}
          </ul>

          <div className='kpi-mobile-totals'>
            <div className='kpi-mobile-row'>
              <span className='kpi-label'>Total Weight</span>
              <span className='kpi-value kpi-value-text'>
                {kpi && kpi?.length ? '100%' : '0.00%'}
              </span>
            </div>
            <div className='kpi-mobile-row'>
              <span className='kpi-label'>Appraisee&rsquo;s Score</span>
              <span className='kpi-value kpi-value-text'>{kpiPercentage}%</span>
            </div>
            {isManager && (
              <div className='kpi-mobile-row'>
                <span className='kpi-label'>Manager&rsquo;s Score</span>
                <span className='kpi-value kpi-value-text'>
                  {isManagerDraft ? '0.00' : kpiPercentageMgr}%
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
